import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      component: () => import('../views/HomePage'),
      children:[{
        path: '/',
        component: () => import('../views/index'),
      },{
        path: '/index',
        component: () => import('../views/index'),
      },{
        path: '/index/service',
        component: () => import('../views/Service'),
      }]
    },
   
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js